import type { CropConfigurations, CropType } from "../Configurations/CropConfiguration/CropConfigurations.js";
import type { Locale } from "./constants.js";
import enCA from "./locales/en-CA/crops.json" with { type: "json" };
import enUS from "./locales/en-US/crops.json" with { type: "json" };
import esMX from "./locales/es-MX/crops.json" with { type: "json" };
import frCA from "./locales/fr-CA/crops.json" with { type: "json" };
import jaJP from "./locales/ja-JP/crops.json" with { type: "json" };
import paIN from "./locales/pa-IN/crops.json" with { type: "json" };
import ptPT from "./locales/pt-PT/crops.json" with { type: "json" };

type ClonalSelectionLabel<C extends CropType> = (typeof CropConfigurations)[C]["hasClonalSelection"] extends true
    ? { clonalSelectionLabel: string }
    : { clonalSelectionLabel?: never };

export type CropCatalogEntry<C extends CropType> = {
    name: string;
    cultivarLabel: string;
    /** Plural noun for the crop's plants, e.g. "Vines", titling a plant count. */
    plantsLabel: string;
} & ClonalSelectionLabel<C>;

export type CropsCatalog = { [C in CropType]: CropCatalogEntry<C> };

export const cropCatalogs = {
    "en-CA": enCA,
    "en-US": enUS,
    "fr-CA": frCA,
    "es-MX": esMX,
    "ja-JP": jaJP,
    "pt-PT": ptPT,
    "pa-IN": paIN,
} satisfies Record<Locale, CropsCatalog>;
